import {observer_utility} from "./observer_class";
import {loading} from "../components/loading_popup/loading_popup";

export namespace app_singleton {

    export type snackbar_data = {text: string, variant: "error" | "success", top?: boolean};
    export type confirm_popup_data = {
        title: string,
        text: string,
        content?: JSX.Element,
        ca: () => Promise<any> | void,
        cancel_ca?: () => Promise<any>
    }

    export type close_popup_data = {
        title: string,
        text: string,
        content?: JSX.Element,
        ca: () => Promise<any> | void,
    }

    export type loading_popup_data = {
        title: string,
        text: string,
        promise: Promise<any>,
        post?: loading.Post
    }

    export interface Observer_snackbar {
        update_snackbar(obj: snackbar_data): void
    }

    export interface Observer_confirm_popup {
        update_confirm_popup(obj: confirm_popup_data): void;
    }

    export interface Observer_close_popup {
        update_close_popup(obj: close_popup_data): void;
    }

    export interface Observer_loading_popup {
        update_loading_popup(obj: loading_popup_data): void
    }

    export class event {

        public static snackbar = new observer_utility.Observer<snackbar_data, Observer_snackbar>
        ((listener, obj) => {
            listener.update_snackbar(obj);
        })

        public static confirm_popup = new observer_utility.Observer<confirm_popup_data, Observer_confirm_popup>
        ( (listener  , obj) => listener.update_confirm_popup(obj) )

        public static close_popup = new observer_utility.Observer<close_popup_data, Observer_close_popup>
        ( (listener  , obj) => listener.update_close_popup(obj) )

        public static loading_popup = new observer_utility.Observer<loading_popup_data, Observer_loading_popup>(
            (listener, obj) => listener.update_loading_popup(obj)
        )

        public static handle_error = async (err: any, default_string: string) => {
            let msg = default_string;
            if(typeof err === "string")
                msg = err;
            if("message" in err && typeof err.message === "string")
                msg = err;
            if("json" in err) {
                const res = err.json();
                if(typeof res === "string")
                    msg = res;
            }
            app_singleton.event.snackbar.notify({
                text: msg,
                variant: "error"
            })
        }


        public static handle_promise = (promise: Promise<any>, success_str: string, error_str: string) => {
            return promise.then(() => app_singleton.event.snackbar.notify({text: success_str, variant: "success"}))
                .catch(() => app_singleton.event.snackbar.notify({text: error_str, variant: "error"}))
        }


        public static format_error = (err: any, default_msg: string) => {
            if(typeof err === "string") return err;
            if(err.message !== undefined && typeof err.message === "string") return err.message;
            return default_msg;
        }

        /**
         *
         * @param condition true genera l'errore e ritorna il true
         * @param text
         */
        public static check_error = (condition: boolean, text: string) => {
            if(condition) app_singleton.event.snackbar.notify({text: text, variant: "error"})
            return condition;
        }

    }

}